export default __webpack_public_path__ + "static/media/hospital.107fae8b.png";